import { useState } from 'react';
import { TicketActivity } from '..';
import useEventListener from '../../../hooks/useEventListener';
import StaticActivityIndicator from './StaticActivityIndicator';

interface Props {
    ticketKey: string;
    showable: boolean;
}

export default function WatchingTicketActivityIndicator({ ticketKey, showable = true }: Props) {
    const [ticketActivity, setTicketActivity] = useState<TicketActivity>();
    useEventListener(
        'DISPATCH_TAB_TICKET_ACTIVITIES_EVENT',
        (e: WindowEventMap['DISPATCH_TAB_TICKET_ACTIVITIES_EVENT']) => {
            const activity = e.detail.activities[ticketKey];
            activity && setTicketActivity(activity);
        }
    );

    return <StaticActivityIndicator showable={showable} activity={ticketActivity} />;
}
